export const defaultIPAddress = "40.80.156.205";
export const defaultCountryCode = "US";
export const defaultCurrencyCode = "USD";

export const downloadCounter = 8;

// export const currentEnv =
//     process.env.REACT_APP_ENVIRONMENT === 'development'
//         ? 'DEVELOPMENT'
//         : process.env.REACT_APP_ENVIRONMENT === 'production'
//         ? 'PRODUCTION'
//         : process.env.REACT_APP_ENVIRONMENT === 'test'
//         ? 'QA'
//         : 'QA'
const currentEnv = `${process.env.REACT_APP_ENVIRONMENT}`;

export const appDomain = () => {
  const url: any = {
    DEVELOPMENT: "http://localhost:3500",
    QA: "##LSTemplate_BaseUrl##",
    STAGING: "https://staging.legalsimpli.com",
    PRODUCTION: "https://legalsimpli.com",
  };
  return url[currentEnv];
};

export const getTenantId = () => {
  const tenantId: any = {
    QA: "A21468BD-04E0-4131-9DC7-54B61FEE0670",
    PRODUCTION: "A21468BD-04E0-4131-9DC7-54B61FEE0670",
    STAGING: "A21468BD-04E0-4131-9DC7-54B61FEE0670",
    DEVELOPMENT: "A21468BD-04E0-4131-9DC7-54B61FEE0670",
  };
  return tenantId[currentEnv];
};

export const getTenantGroupId = () => {
  const tenantId: any = {
    QA: "580C8B5A-DB83-4834-14EF-08D9501E735D",
    PRODUCTION: "9C7D9766-9EBF-47A4-94E6-3F1F50CD4B2F",
    STAGING: "9C7D9766-9EBF-47A4-94E6-3F1F50CD4B2F",
    DEVELOPMENT: "580C8B5A-DB83-4834-14EF-08D9501E735D",
  };
  return tenantId[currentEnv];
};

export const blobSignature = () => {
  const blobSign: any = {
    QA: "?sv=2020-04-08&si=pdfsimpliuserstest&sr=c&sig=C5E6T6kNLW0pcWAW2l2KrY1pboKjZQh1IhO%2FP9iozO8%3D",
    PRODUCTION:
      "?sv=2017-04-17&si=pdfsimpliusers&sr=c&sig=tLI3WycMdpg2v5sTxxX1RVi22y9Hz6tI8eeyOriK%2BjE%3D",
    STAGING:
      "?sv=2017-04-17&si=pdfsimpliusers&sr=c&sig=tLI3WycMdpg2v5sTxxX1RVi22y9Hz6tI8eeyOriK%2BjE%3D",
    DEVELOPMENT:
      "?sv=2020-04-08&si=pdfsimpliuserstest&sr=c&sig=C5E6T6kNLW0pcWAW2l2KrY1pboKjZQh1IhO%2FP9iozO8%3D",
  };
  return blobSign[currentEnv];
};

export const getTokenExIframeJs = () => {
  const tokenExJS: any = {
    QA: `https://static-qa.worksimpli.io/cdn/sso-dashboard/token-iframe-script.js?v=${Date.now()}`,
    PRODUCTION: `https://static.worksimpli.io/cdn/sso-dashboard/token-iframe-script.js?v=${Date.now()}`,
    STAGING: `https://static.worksimpli.io/cdn/sso-dashboard/token-iframe-script.js?v=${Date.now()}`,
    DEVELOPMENT: `https://static-qa.worksimpli.io/cdn/sso-dashboard/token-iframe-script.js?v=${Date.now()}`,
  };
  return tokenExJS[currentEnv];
};

export const getStorageAccount = () => {
  const storageAccount: any = {
    QA: `https://test.legalsimpli.com`,
    PRODUCTION: `https://legalsimpli.com`,
    STAGING: `https://staging.legalsimpli.com`,
    DEVELOPMENT: `https://local.templatehtml.com/`
  };
  return storageAccount[currentEnv];
};

export const getFacebookClientId = () => {
  return "725764382922248";
};

export const getGoogleClientId = () => {
  return "857841731210-2vab128a29c3vhspiqvt32a4ukf10oaa.apps.googleusercontent.com";
};
export const hidePaypal = (currencyCD: any) => {
  let isHide = false;
  const currenciesToHide = "ZAR|TRY|MYR|SAR|AED";
  if (currenciesToHide.split("|").includes(currencyCD)) {
    isHide = true;
  }
  return isHide;
};
export const EnableHomeRenderFromBlob = () => {
  const HomeRenderFromBlob: any = {
    QA: true,
    PRODUCTION: true,
    STAGING: true,
    DEVELOPMENT: true,
  };
  return HomeRenderFromBlob[currentEnv];
};
export const getInitializationVector = () => {
  const ivKey: any = {
    QA: "2908290630030702",
    PRODUCTION: "2908290630030702",
    STAGING: "2908290630030702",
    DEVELOPMENT: "2908290630030702",
  };
  return ivKey[currentEnv];
};

export const isPaymentMSEnable = () => {
  const isPaymentMSEnable: any = {
    QA: true,
    PRODUCTION: true,
    STAGING: true,
    DEVELOPMENT: true,
  };
  return isPaymentMSEnable[currentEnv];
};
export const sasTokenExpiryHours = 48;

export const getBlobUri = () => {
  const BlobUri: Record<string, string> = {
    PRODUCTION: "https://prodlegalsimplistorage.blob.core.windows.net/",
    STAGING: "https://prodlegalsimplistorage.blob.core.windows.net/",
    QA: "https://devlegalsimpli.blob.core.windows.net/",
    DEVELOPMENT: "https://devlegalsimpli.blob.core.windows.net/",
  };
  return BlobUri[currentEnv];
};
